export const PROCESS_TYPES = {
  ADMINISTRATIVE: 'administrative',
  JUDICIAL: 'judicial',
  CRIMINAL: 'criminal',
}

export const PROCESS_TYPES_MESSAGES = {
  administrative: 'processo administrativo',
  judicial: 'processo judicial',
  criminal: 'processo criminal',
}

export const REVIEW_TYPES = {
  WAITING_DECISIONS: 'WAITING_DECISIONS',
  APPROVED: 'APPROVED',
  REPROVED: 'REPROVED',
}

export const REVIEW_TYPES_MESSAGES = {
  WAITING_DECISIONS: 'Aguardando análise',
  APPROVED: 'Aprovado',
  REPROVED: 'Reprovado',
}

export const REVIEW_STATUS_MESSAGES = {
  AWAITING_DECISION: 'Aguardando decisão',
  REVIEWED: 'Finalizado',
  SUSPENDED: 'Suspenso',
  PENDING_PROSPECT_FEEDBACK: 'Aguardando feedback do assessor',
}

export const REVIEW_RESULT_MESSAGES = {
  APPROVED: 'Aprovado',
  REPROVED: 'Reprovado',
}
